import MobileDetect from 'mobile-detect';

const mobileDetect = new MobileDetect(window.navigator.userAgent);

export default {
    isMobile: !!mobileDetect.mobile(),
    isPhone: !!mobileDetect.phone(),
    isTablet: !!mobileDetect.tablet(),
    inIframe: window.self !== window.top,
};
